/*=========================================================================================
  File Name: module-misaorder.js
  Description: misaorder Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-misastore-state';
import mutations from './module-misastore-mutations';
import actions from './module-misastore-actions';
import getters from './module-misastore-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
